
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h25v25H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('circle',{attrs:{"data-name":"Ellipse 4","cx":"12.5","cy":"12.5","r":"12.5","fill":"#adadad"}}),_c('path',{attrs:{"d":"M12.806 12.543l3.224-3.225a.186.186 0 0 0-.263-.263l-3.224 3.224-3.225-3.224a.186.186 0 0 0-.263.263l3.224 3.225-3.224 3.224a.187.187 0 0 0 .264.264l3.224-3.224 3.224 3.224a.185.185 0 0 0 .132.054.186.186 0 0 0 .132-.318l-3.224-3.224z","fill":"#fff","stroke":"#fff","stroke-width":"2"}})])])
          )
        }
      }
    